import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { FaCamera, FaPlus } from "react-icons/fa6";
import { PiTrashSimpleBold } from "react-icons/pi";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import profilePic from "../assets/images/profile-card.svg"; // Replace with actual profile image path
import { FiEdit } from "react-icons/fi";
import { GrRevert } from "react-icons/gr";

const PostCreator = () => {
    const [firstPollOption, setFirstPollOption] = useState(""); // Separate state for first input
    const [postType, setPostType] = useState("post");
    const [text, setText] = useState("");
    const [files, setFiles] = useState([]);
    const [pollOptions, setPollOptions] = useState([""]); // Include first option
    const [pollLength, setPollLength] = useState({ days: "", hours: "", minutes: "" });

    // Handle file selection
    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles((prevFiles) => [
            ...prevFiles,
            ...selectedFiles
        ]);
    };

    // Remove selected file
    const removeFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
    };

    // Handle Poll Option Add
    const addPollOption = () => {
        setPollOptions([...pollOptions, ""]);
    };

    // Handle Poll Option Change
    const handlePollOptionChange = (index, value) => {
        const updatedPollOptions = [...pollOptions];
        updatedPollOptions[index] = value;
        setPollOptions(updatedPollOptions);
    };

    // Handle Poll Option Delete
    const removePollOption = (index) => {
        setPollOptions(pollOptions.filter((_, i) => i !== index));
    };

    // **Fix: Reset Data When Switching Between "Post" and "Poll"**
    const handlePostTypeChange = (type) => {
        setText("");         // Clear text input
        setFiles([]);        // Clear uploaded files
        setFirstPollOption(""); // Reset first input separately
        setPollOptions([]);  // Clear poll options
        setPollLength({ days: "", hours: "", minutes: "" }); // Reset poll length
        setPostType(type);   // Set new post type
    };

    // Reset function to clear everything
    const resetForm = () => {
        setText("");
        setFiles([]);
        setFirstPollOption(""); // Reset first input separately
        setPollOptions([]); // Clear additional poll options
        setPollLength({ days: "", hours: "", minutes: "" });
    };

    return (
        <div className="post-creator">
            <div className="post-input-section">
                <img src={profilePic} alt="Profile" className="profile-pic" />
                <textarea
                    className="post-textarea"
                    placeholder="What’s on your mind?"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                ></textarea>
            </div>

            <div className="post-action-part">
                <div className="post-options-wraper">
                    <div className="create-post-container">
                        <div className="post-options">
                            {/* Post Radio Button */}
                            <label className={`custom-radio ${postType === "post" ? "active" : ""}`}>
                                <input
                                    type="radio"
                                    name="postType"
                                    value="post"
                                    checked={postType === "post"}
                                    onChange={() => handlePostTypeChange("post")}
                                />
                                <span className="radio-box"></span> Post
                            </label>

                            {/* Poll Radio Button */}
                            <label className={`custom-radio ${postType === "poll" ? "active" : ""}`}>
                                <input
                                    type="radio"
                                    name="postType"
                                    value="poll"
                                    checked={postType === "poll"}
                                    onChange={() => handlePostTypeChange("poll")}
                                />
                                <span className="radio-box"></span> Poll
                            </label>
                        </div>
                    </div>

                    {/* File Upload Section */}
                    {(postType === "post" || postType === "poll") && (
                        <div className="file-upload-section">
                            <label className="file-upload">
                                <input
                                    type="file"
                                    accept="image/*,video/*"
                                    multiple={postType === "post"}  // Allow multiple only for posts
                                    onChange={handleFileChange}
                                />
                                <FaCamera className="icon" /> <span>Photo/Video</span>
                            </label>
                        </div>
                    )}
                </div>

                <div className="post-buttons">
                    <Button variant="link" onClick={resetForm}>
                        <GrRevert />
                        <span>Discard</span>
                    </Button>
                    <Button type="submit" size="lg" className="btn btn-primary">
                        <FiEdit />
                        <span>Create Post</span>
                    </Button>
                </div>
            </div>

            {/* Display Uploaded Images/Videos - Only Visible if `files.length > 0` */}

            {files.length > 0 && (
                <div className="uploaded-files">
                    {files.map((file, index) => (
                        <div key={index} className="file-thumbnail">
                            {file.type.startsWith("image") ? (
                                <img src={URL.createObjectURL(file)} alt="Uploaded" className="thumbnail" />
                            ) : (
                                <video src={URL.createObjectURL(file)} className="thumbnail" controls />
                            )}
                            <span className="remove-btn" onClick={() => removeFile(index)}>×</span>
                        </div>
                    ))}

                    {/* Add More Files (+ Button) - Only for posts */}
                    {postType === "post" && (
                        <label className="add-more">
                            <input type="file" accept="image/*,video/*" multiple onChange={handleFileChange} />
                            <FaPlus className="plus-icon" />
                        </label>
                    )}
                </div>
            )}



            {/* Poll Options Section */}
            {postType === "poll" && (
                <div className="poll-section">
                    <p>Poll Options</p>
                    {/* First Poll Option - Separate */}
                    <div className="poll-option first-option">
                        <span className="option-number">0.</span>
                        <div className="poll-option-items">
                            <Form.Control
                                type="text"
                                placeholder="Add poll option"
                                value={firstPollOption} // Controlled input
                                onChange={(e) => setFirstPollOption(e.target.value)}
                            />
                            <Button className="add-btn" onClick={addPollOption}>
                                <FaPlus size={18} />
                            </Button>
                        </div>
                    </div>

                    {/* Dynamically Added Poll Options */}
                    {pollOptions.map((option, index) => (
                        <div key={index} className="poll-option">
                            <span className="option-number">{index + 1}.</span>
                            <div className="poll-option-items">
                                <Form.Control
                                    type="text"
                                    placeholder={`Option ${index + 1}`}
                                    value={option}
                                    onChange={(e) => handlePollOptionChange(index, e.target.value)}
                                />
                                <Button variant="danger" className="remove-poll-btn" onClick={() => removePollOption(index)}>
                                    <PiTrashSimpleBold size={18} />
                                </Button>
                            </div>
                        </div>
                    ))}

                    {/* Poll Length Section */}
                    <div className="poll-length-wraper mt-15">
                        <p>Poll Length</p>
                        <div className="poll-length">
                            <FloatingLabel controlId="floatingDays" label="Days">
                                <Form.Control
                                    type="number"
                                    min="0"
                                    value={pollLength.days}
                                    onChange={(e) => setPollLength({ ...pollLength, days: e.target.value })}
                                    placeholder="Days"
                                />
                            </FloatingLabel>

                            <FloatingLabel controlId="floatingHours" label="Hours">
                                <Form.Control
                                    type="number"
                                    min="0"
                                    max="23"
                                    value={pollLength.hours}
                                    onChange={(e) => setPollLength({ ...pollLength, hours: e.target.value })}
                                    placeholder="Hours"
                                />
                            </FloatingLabel>

                            <FloatingLabel controlId="floatingMinutes" label="Minutes">
                                <Form.Control
                                    type="number"
                                    min="0"
                                    max="59"
                                    value={pollLength.minutes}
                                    onChange={(e) => setPollLength({ ...pollLength, minutes: e.target.value })}
                                    placeholder="Minutes"
                                />
                            </FloatingLabel>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PostCreator;
